import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ReasonI } from '@interfaces/services/services'

interface PatientPreviousReasonI {
    existPreviousReasons: ReasonI[]
}

export const patientPreviousReasonsSlice = createSlice({
    name: 'patient-previous-reasons',
    initialState: {
        existPreviousReasons:[]
    } as unknown as PatientPreviousReasonI,
    reducers: {
        setPatientPreviousReasons: (state, action: PayloadAction<ReasonI[]>) => {
            state.existPreviousReasons = action.payload
        },
        cleanPatientPreviousReasons: (state) => {
            state.existPreviousReasons = []   
        },
    },
})

export const { setPatientPreviousReasons,cleanPatientPreviousReasons} = patientPreviousReasonsSlice.actions
export default patientPreviousReasonsSlice.reducer
